export default "__VITE_ASSET__CvZkpu32__"